/* unplugin-vue-components disabled */import { render } from "./photo-upload-business.vue?vue&type=template&id=54eaa4d5&scoped=true"
import script from "./photo-upload-business.vue?vue&type=script&lang=js"
export * from "./photo-upload-business.vue?vue&type=script&lang=js"

import "./photo-upload-business.vue?vue&type=style&index=0&id=54eaa4d5&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/生产环境微信商家助手yinboshi_weixin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54eaa4d5"]])

export default __exports__